import { forwardRef } from 'react';
import { CheckboxProps } from '@theme/components/types';
import { twMerge } from 'tailwind-merge';

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>((props, ref) => {
  const { children, inputClassName, wrapperClassName, checked, error, ...rest } =
    props;

  const isControlled = checked !== undefined;

  return (
    <label
      className={twMerge('flex flex-col text-xs', props.className)}
      id={props.id}
    >
      <div className={twMerge('flex items-center', wrapperClassName)}>
        <input
          type="checkbox"
          {...rest}
          ref={ref}
          {...(isControlled
            ? { checked, readOnly: rest.onChange === undefined }
            : {})}
          className={twMerge(
            'w-3 h-3 shrink-0 accent-primary-black',
            inputClassName
          )}
        />
        {children && <span className="ml-2">{children}</span>}
      </div>
      {error && (
        <span className="mt-1 text-sm text-error">{error.message}</span>
      )}
    </label>
  );
});

Checkbox.displayName = 'Checkbox';

export { Checkbox };
